import React from 'react';

import { useStoreContext } from 'features/store';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { FriesSvg as UnauthenticatedEmptyStateImage } from '../../../../../components/svgs/fries';

import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const NoRecentOrdersEmptyState = () => {
  const { isStoreOpenAndAvailable } = useStoreContext();

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <UnauthenticatedEmptyStateImage />
      </ImageWrapper>
      <HeaderText testID="text-no-recent-items">{t('noRecentItemsHeader')}</HeaderText>
      <SubText>{t('noRecentItemsSubheader')}</SubText>
      <StyledActionButtonLink
        to={isStoreOpenAndAvailable ? `${routes.menu}` : `${routes.storeLocator}`}
        style={{ marginTop: '10%' }}
      >
        {t('orderNow')}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default NoRecentOrdersEmptyState;
